module.exports = __webpack_public_path__ + "img/woman-headset.5b6a31f.svg";